var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkAdd = function SvgBookmarkAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M682.667 469.333V766.72l-213.333-91.307-213.333 91.307V213.333h256V128h-256c-46.933 0-85.333 38.4-85.333 85.333V896l298.667-128 298.667 128V469.333h-85.333zm170.666-170.666H768V384h-85.333v-85.333h-85.333v-85.333h85.333v-85.333H768v85.333h85.333z"
  })));
};
export default SvgBookmarkAdd;